var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconZoomOutBlack = function SvgIconZoomOutBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1B1A1F",
    d: "m19.542 20.577-6.28-6.281q-.75.62-1.726.97-.975.35-2.017.35-2.564 0-4.34-1.776T3.405 9.502q0-2.565 1.775-4.34 1.776-1.777 4.339-1.777 2.562 0 4.34 1.776 1.776 1.775 1.776 4.339 0 1.071-.36 2.046a5.7 5.7 0 0 1-.959 1.696l6.28 6.281zM9.52 14.115q1.933 0 3.274-1.341 1.342-1.34 1.342-3.274 0-1.932-1.342-3.274-1.34-1.341-3.274-1.341-1.932 0-3.274 1.341Q4.904 7.568 4.904 9.5q0 1.933 1.341 3.274 1.342 1.342 3.274 1.342M7.135 10.25v-1.5h4.769v1.5z"
  })));
};
export default SvgIconZoomOutBlack;